<p>location-detail-ctl works!</p>
